import { useState, useEffect, useMemo } from "react";
import { initChat, resetChatSession } from "../api/chat.api";
import { useErrorStore } from "../store/error.store";
import { sessionManager } from "../services/session.service";
import { getChatbotConfig } from "../utils/utils";

/**
 * チャットパネルの初期化
 */
export function useInitChat() {
  const config = useMemo(() => getChatbotConfig(), []);
  const {
    corporate_id: corporateId,
    chatbot_id: chatbotId,
    config_key: configKey,
    corporate_uuid: corporateUuId,
  } = config;
  const setError = useErrorStore((state) => state.setError);
  const [sessionKey, setSessionKey] = useState<string | null>(null);

  useEffect(() => {
    // 現在のセッションが有効かどうか
    // if (sessionManager.isSessionValid()) {
    //   const existingSession = sessionManager.getSessionKey();
    //   setSessionKey(existingSession);
    //   return;
    // }

    // 初期化処理
    const controller = new AbortController();
    const signal = controller.signal;

    const initialize = async () => {
      try {
        const result = await initChat(signal);
        sessionManager.setSession(result.data.session_key, chatbotId);
        setSessionKey(result.data.session_key);
      } catch (error: unknown) {
        if (error instanceof Error && error.name !== "AbortError") {
          setError(error.message || "サーバエラーで初期化が失敗しました");
        } else if (error instanceof Error && error.name === "AbortError") {
          // 開き、閉じての仕様の残留
          console.warn("初期化処理がキャンセルされました");
        } else {
          setError("初期化が失敗しました");
        }
      }
    };

    initialize();

    return () => {
      controller.abort();
    };
  }, [corporateId, chatbotId, configKey, setError, corporateUuId]);

  return { sessionKey };
}

/**
 * チャットパネルの会話をリセット
 */
export function useResetChatSession() {
  const config = useMemo(() => getChatbotConfig(), []);
  const { chatbot_id: chatbotId } = config;
  const setError = useErrorStore((state) => state.setError);
  const [newSessionKey, setNewSessionKey] = useState<string | null>(null);

  const resetSession = async () => {
    try {
      const result = await resetChatSession();
      sessionManager.setSession(result.data.session_key, chatbotId);
      setNewSessionKey(result.data.session_key);
      return { success: result.success, key: result.data.session_key };
    } catch (error: unknown) {
      if (error instanceof Error) {
        setError(error.message || "サーバエラーで会話リセットが失敗しました");
      } else {
        setError("会話リセットが失敗しました");
      }
      return { success: false, key: "" };
    }
  };

  //keyが"chatbot_session_"から始まるセッションだけを削除する
  const resetSessionKey = (sessionKey: string) => {
    sessionManager.clearSession();
    sessionManager.setSession(sessionKey, chatbotId);
  };

  return { newSessionKey, resetSession, resetSessionKey };
}
